import {
  activePlugins,
  startPluginShared,
  startPluginInitChild,
} from './index';

// main entry point for creating a plugin view
async function invokePlugin(instanceId, entryPoint, element, respondToInitChildCallback) {
  if (activePlugins.has(instanceId)) {
    throw new Error(`courseware ${instanceId} already initialized`);
  }

  activePlugins.set(instanceId, {
    element,
    respondToInitChildCallback,
  });

  if (!respondToInitChildCallback) {
    const driver = await startPluginShared(instanceId, entryPoint, element);
    const entry = activePlugins.get(instanceId);
    entry.driver = driver;
  } else {
    startPluginInitChild(instanceId, entryPoint, respondToInitChildCallback);
  }
}

export default invokePlugin;
